import { useCallback } from "react"
import { ShareIcon } from "components/icons"
import { IconButton } from "@mui/material"

export const ShareIconButton = ({
  title,
  text,
  url,
  onClick = () => {},
  label = "Share",
  ...props
}) => {
  const isSharebale = !!navigator.share
  const handleClick = useCallback(async () => {
    onClick()
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url })
        alert("Share successfull")
      } catch (err) {
        console.log("Error: ", err)
      }
    } else {
      console.log("Native Web Sharing not supported")
    }
  }, [onClick, text, title, url])
  return (
    isSharebale && (
      <IconButton color="primary" onClick={handleClick} {...props}>
        <ShareIcon sx={{ width: 15 }} />
      </IconButton>
    )
  )
}
